import auth from "@/services/ExerciseInitAuth";

const fetch = () =>
  auth.get(`${process.env.VUE_APP_EXERCISE_API}nu_exams/settings/`);

export default {
  fetch
};
